import { render, staticRenderFns } from "./RecuperarCuenta.vue?vue&type=template&id=199e867a"
import script from "./RecuperarCuenta.vue?vue&type=script&lang=js"
export * from "./RecuperarCuenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports